import React from 'react';
import { IApp } from '../Interfaces/IApp';
import { Box, Button, Typography } from '@mui/material';
import { ActivExtensionCard } from './ActivExtensionCard';
import { LoadingSpinner } from '../core/LoadingSpinner';
import { useGetSettingAppArray } from '../hooks/reactQuerys/AppQueries';

interface IProps {
  appArray: IApp[];
}

export const ActivExtensionTab: React.FC<IProps> = ({ appArray }) => {
  const { appSettingArray, isLoadingAppSettingArray, refetchAppSettingArray } =
    useGetSettingAppArray();

  if (isLoadingAppSettingArray) {
    return <LoadingSpinner />;
  }

  if (!appSettingArray) {
    return (
      <Box sx={{ m: 2 }}>
        <Typography>
          Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut.
          <Button onClick={() => refetchAppSettingArray()}>
            Erneut versuchen
          </Button>
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Typography variant='h6'>Aktive Erweiterungen</Typography>
      {appArray.map(app => (
        <ActivExtensionCard
          key={`app-${app.idApp}`}
          app={app}
          appSettingArray={appSettingArray}
          onSave={() => refetchAppSettingArray()}
        />
      ))}
    </>
  );
};
